export enum WirePremiumFrequencies {
  Monthly = 'Monthly',
  Yearly = 'Yearly',
  First = 'First',
}

type WirePremiumFrequency = 'Fortnightly' | 'Monthly' | 'Yearly' | 'First';

export type WirePremium = {
  id: string;
  gross: number;
  technical?: number;
  name: string;
  net?: number;
  base?: number;
  inclusion?: boolean;
  description?: string;
  selected?: boolean;
  sd: number;
  fsl: number;
  gst: number;
  frequency?: WirePremiumFrequency;
  instalment?: number;
};
